import { EnumSchema, FromSchema, ZodDate, ZodObjectId } from '@40seas/entities/common';
import { Currency } from '@40seas/models';
import { z } from 'zod';
import { CurrencyExchangeProviderType } from './currency-exchange.provider.enum';

export const CurrencyExchangeSchema = z.object({
    marketRate: z.number().optional(),
    rate: z.number(),
    from: EnumSchema(Currency),
    to: EnumSchema(Currency),
    date: ZodDate.optional(),
    provider: EnumSchema(CurrencyExchangeProviderType).optional(),
    feeDefinition: ZodObjectId.optional(),
    providerQuoteId: z.string().optional(),
    quote: z.string().optional(),
});

export class CurrencyExchange extends FromSchema(CurrencyExchangeSchema) {
    marketRate: number;
    rate: number;
    from: Currency;
    to: Currency;
    date?: Date;
    provider: CurrencyExchangeProviderType;
    feeDefinition: string;
    providerQuoteId?: string;
    quote?: string;
}
